export { subscribe, MicroFrontend, type MicroFrontendProps } from './MicroFrontend';
